import angular from 'angular';

/* @ngInject */
class Auth {
	constructor($auth, localStorageService, $q, $http, $state) {
		this.$auth               = $auth;
		this.localStorageService = localStorageService;
		this.$q                  = $q;
		this.$http               = $http;
		this.$state              = $state;

		this.user = localStorageService.get('user');

		this.callbacks = {
			onLogin:  [],
			onLogout: [],
		};
	}

	setUser(user) {
		this.user = user;
		this.localStorageService.set('user', user);

		return this;
	}

	getUser() {
		return this.user;
	}

	getType() {
		if (this.getUser()) {
			return this.getUser().type;
		} else {
			return null;
		}
	}

	getToken() {
		return this.$auth.getToken();
	}

	getAuth() {
		return this.$auth;
	}

	authenticate(credentials) {
		let deferred = this.$q.defer();

		this.$auth
		    .login(credentials)
		    .then(
			    () => {
				    deferred.notify();

				    this.refreshUser()
				        .then((user) => {
					        deferred.resolve(user);
				        })
				        .catch(() => {
					        deferred.reject();
				        });
			    },
			    () => {
				    deferred.reject();
			    },
		    );

		return deferred.promise;
	}

	refreshToken() {
		let deferred = this.$q.defer();

		this.$http
		    .get(`${process.env.API_ENDPOINT}auth/refresh`)
		    .then((data) => {
			    this.$auth.setToken(data.data.token);

			    deferred.resolve(data.data.token);
		    }, () => {
			    this.logout();

			    deferred.reject();
		    });

		return deferred.promise;
	}

	resetPassword(credentials) {
		let deferred = this.$q.defer();

		this.$http
		    .post(`${process.env.API_ENDPOINT}auth/reset-password`, {
			    username: credentials.username,
		    })
		    .then(() => {
			    deferred.resolve();
		    }, () => {
			    deferred.reject();
		    });

		return deferred.promise;
	}

	setPassword(credentials) {
		let deferred = this.$q.defer();

		this.$http
		    .post(`${process.env.API_ENDPOINT}auth/set-password`, {
			    password: credentials.password,
		    })
		    .then(() => {
			    deferred.notify();

			    this.refreshUser()
			        .then((user) => {
				        deferred.resolve(user);
			        })
			        .catch(() => {
				        deferred.reject();
			        });
		    }, () => {
			    deferred.reject();
		    });

		return deferred.promise;
	}

	refreshUser() {
		let deferred = this.$q.defer();

		this.$http
		    .get(`${process.env.API_ENDPOINT}auth/me`, {
			    params: {
				    'include': 'staff,supportWorker,workable.latestIdBadge,permissions',
			    },
		    })
		    .then((data) => {
			    this.setUser(data.data);

			    deferred.resolve(data.data);
		    })
		    .catch(() => {
			    deferred.reject();
		    });

		return deferred.promise;
	}

	logout() {
		let deferred = this.$q.defer();

		const user = this.getUser();

		this.$auth.logout()
		    .then(() => {
			    deferred.resolve(user);

			    this.fireOnLogoutCallbacks(user);
		    });

		return deferred.promise;
	}

	impersonateUser(userId) {
		let deferred = this.$q.defer();

		this.$http
		    .post(`${process.env.API_ENDPOINT}auth/impersonate`, {
			    user: userId,
		    })
		    .then((data) => {
			    this.$auth.setToken(data.data.token);

			    deferred.resolve(data.data.token);
		    }, () => {
			    this.logout();

			    deferred.reject();
		    });

		return deferred.promise;
	}

	isLoggedIn() {
		return this.$auth.isAuthenticated() && this.getUser() != null;
	}

	isSupportWorker() {
		return this.isLoggedIn() && this.getType() == 'supportWorker';
	}

	isStaff() {
		return this.isLoggedIn() && this.getType() == 'staff';
	}

	isImpersonating() {
		return this.isLoggedIn() && this.$auth.getPayload() && this.$auth.getPayload().imp;
	}

	hasPermission(permission) {
		return this.isLoggedIn() && this.getUser().permissions && this.getUser().permissions.length > 0 && this.getUser()
		                                                                                                       .permissions
		                                                                                                       .indexOf(permission) !== -1;
	}

	redirectIfUnauthorized(permission, target) {
		if (!this.hasPermission(permission)) {
			this.$state.go(target);
		}
	}

	onLogin(callback) {
		this.callbacks.onLogin.push(callback);
	}

	fireOnLoginCallbacks() {
		angular.forEach(this.callbacks.onLogin, (callback) => {
			callback();
		});
	}

	onLogout(callback) {
		this.callbacks.onLogout.push(callback);
	}

	fireOnLogoutCallbacks(data) {
		angular.forEach(this.callbacks.onLogout, (callback) => {
			callback(data);
		});
	}
}

export default Auth;


// WEBPACK FOOTER //
// ./src/js/services/auth/index.js